import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12 mb-4"},[_c(VCard,{attrs:{"flat":""}},[_c('apexchart',{attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }